import React__default, { useState } from 'react';
import cn from 'classnames';
import styles from 'ui-components/Menu.scss';

var Menu = function Menu(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? "left" : _ref$iconPosition,
    counter = _ref.counter,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block, className),
    onMouseEnter: function onMouseEnter() {
      return setOpen(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.title
  }, icon !== null && iconPosition === "left" && icon, title && /*#__PURE__*/React__default.createElement("p", null, title), icon !== null && iconPosition === "right" && icon, typeof counter !== "undefined" && counter !== null && /*#__PURE__*/React__default.createElement("span", {
    className: cn(styles.counter)
  }, " (" + counter + ")")), open && /*#__PURE__*/React__default.createElement("nav", {
    className: styles.dropdown,
    onClick: function onClick() {
      return setOpen(false);
    }
  }, children));
};

export { Menu };
//# sourceMappingURL=index.js.map
